import { Wrench } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconWrench12Line = createIcon(Wrench, 12, "Line");
export const IconWrench16Line = createIcon(Wrench, 16, "Line");
export const IconWrench20Line = createIcon(Wrench, 20, "Line");
export const IconWrench24Line = createIcon(Wrench, 24, "Line");
export const IconWrench32Line = createIcon(Wrench, 32, "Line");
export const IconWrench48Line = createIcon(Wrench, 48, "Line");
export const IconWrench64Line = createIcon(Wrench, 64, "Line");
